module.exports = __webpack_public_path__ + "img/icon_check.44d1a6bf.svg";